<template>
  <div class="space-y-1">
    <p class="text-xs text-gray-380 font-medium">{{ title }}</p>
    <div class="text-sm">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
}
defineProps<Props>();
</script>

<style scoped></style>
